module.exports = __webpack_public_path__ + "static/media/loc7_img6.a6760143.jpg";